import { CONTRACT_TYPES, TENANT_NAMES } from '@constants';
import { fixedNumber, formatAmount, formatDate, timeFromNow } from '@utils';
import theme from 'config/theme';
import { URLS } from 'layouts/DrawerLayout/constants';

export const normalizeOrders = (data = []) => {
  return data.map((item) => ({
    rawItem: item,
    ...item,
    name: item.orderName || '-',
    text: item.orderName || '-',
    value: item.id,
    createdAt: item?.createdAt
      ? formatDate(item?.createdAt, 'dd-MM-yyyy')
      : '-',
    customerName: `${item.firstName} ${item.lastName}`,
    customerId: item.userId,
    assignee: item?.assignee || '',
  }));
};

export const normalizeBookings = (data = []) => {
  return data.map((booking) => {
    const contractType =
      booking?.contractType === CONTRACT_TYPES.open ? 'Open' : 'Fixed';
    const date = booking?.created_at
      ? formatDate(booking?.created_at, 'dd/MM/yyyy')
      : '-';
    const contractPeriod = `${booking.contract_period} Month`;

    return {
      id: booking?.id,
      href: `${URLS.bookings}/${booking?.id}`,
      description: booking?.vehicle?.title || '-',
      heading: `${booking?.first_name} ${booking?.last_name}`,
      stage: booking.stage,
      date,
      contractType,
      fullName: `${booking?.first_name} ${booking?.last_name}`,
      created_at: date,
      updated_at: booking?.updated_at
        ? formatDate(booking?.updated_at, 'dd/MM/yyyy HH:mm')
        : '-',
      timeAgo: timeFromNow(booking?.created_at),
      email: booking?.email,
      pipeDriveId: booking?.pipedrive?.id,
      pipeDriveUrl: booking?.pipedrive?.url,
      is_active: booking?.is_active || '',
      region: booking?.region || '-',
      contract: booking?.contract || '-',
      contractPeriod,
      phoneNumber: booking?.phone_number || '-',
      vehicle: booking?.vehicle?.title || '-',
      origin: booking?.origin,
      skuId: booking?.vehicle?.id,
      tenant: TENANT_NAMES[booking?.tenant],
      price: booking?.products?.[0]?.finalPrice?.number
        ? formatAmount(fixedNumber(booking?.products?.[0]?.finalPrice?.number))
        : '',
      fee: booking?.products?.[0]?.finalPrice?.number
        ? formatAmount(fixedNumber(booking?.products?.[0]?.finalPrice?.number))
        : '-',
      initialFee: booking?.products?.[0]?.price?.number
        ? formatAmount(fixedNumber(booking?.products?.[0]?.price?.number))
        : '-',
      userInternalId: booking?.userInternalId || '-',
      userId: booking?.user_id,
      labels: [
        {
          text: contractType,
          styles: {
            backgroundColor: theme.palette.yellows.yellow200,
            color: theme.palette.yellows.yellow900,
          },
        },
        {
          text: booking?.origin,
          styles: {
            backgroundColor: theme.palette.blues.primaryBlue200,
            color: theme.palette.blues.primaryBlue800,
          },
        },
        {
          text: contractPeriod,
          styles: {
            backgroundColor: theme.palette.yellows.yellow200,
            color: theme.palette.yellows.yellow900,
          },
        },
      ],
    };
  });
};
